import { useEffect, useState } from 'react';
import { QueryStatus } from 'src/types';
import { HttpLEP } from '../api/httpLEP';
import {OperacionLEPEmisorView} from "../types/dto";

export const useEmisorLimite = (idOperacion: number) => {
    const [limites, setLimites] = useState<OperacionLEPEmisorView[]>();
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle);

    const fetch = () => {
        if (!idOperacion) return;

        setStatus(QueryStatus.Loading);

        HttpLEP.getEmisores(idOperacion)
            .then(data => {
                setLimites(data);
                setStatus(QueryStatus.Success);
            })
            .catch(error => {
                setStatus(QueryStatus.Error);
                console.error(error);
            });
    };

    const refetch = () => fetch();

    useEffect(() => {
        fetch();
    }, [idOperacion]);

    return { limites, refetch, status };
};